import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Layout Components
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

// Page Components
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Capabilities from "@/pages/Capabilities";
import Safety from "@/pages/Safety";
import Projects from "@/pages/Projects";
import Contact from "@/pages/Contact";
import Careers from "@/pages/Careers";
import Vendor from "@/pages/Vendor";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/capabilities" element={<Capabilities />} />
            <Route path="/safety" element={<Safety />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/vendor" element={<Vendor />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
